// React & Libraries
import React, { Fragment } from 'react';

// Helpers
import Helpers from '@Apis/helpers';
import { handleFileChange } from '../helper';

// Components
import ViewDocumentFooterDetails from '../../../../Common/ViewDocFooterLeftSection';

function ViewPackingSlipFooter({
  selectedSO,
  fileList,
  getAttachmentByIdLoading,
  updateAttachmentLoading,
  user,
  updateAttachment,
  getAttachmentById,
  dispatch,
}) {
  return (
    <Fragment>
      <div className="view-document__totals-wrapper">
        <ViewDocumentFooterDetails
          fileList={fileList}
          disableAttachment={getAttachmentByIdLoading || updateAttachmentLoading}
          onFileChange={(value) => handleFileChange({ fileListData: value, selectedSO, updateAttachment, getAttachmentById, dispatch })}
          canUpdateAttachment={Helpers.getPermission(Helpers.permissionEntities.PACKING_SLIP, Helpers.permissionTypes.UPDATE, user)}
          termsAndConditions={selectedSO?.terms_and_conditions}
          orderNote={selectedSO?.shopify_so_object?.note}
        />
      </div>
    </Fragment>
  );
}

export default ViewPackingSlipFooter;